<div class="lp-carousel-categories">
  <ng-container *ngIf="selectedMainCategory; else categoryCellTmp">
    <ng-container *ngIf="selectedMainCategory.items && selectedMainCategory.items.length > 1">
      <app-carousel [loading]="false">
        <!-- Список вложенных фильтров -->
        <lp-category-selection
          [mainCategory]="selectedMainCategory"
          [selectedCategory]="selectedCell"
          (selectedCategoryChange)="onSelectCategory($event)"
        ></lp-category-selection>
      </app-carousel>
    </ng-container>
  </ng-container>

  <ng-template #categoryCellTmp>
    <app-carousel [loading]="!categories || !activeCollections">
      <ng-container *ngIf="categories && categories.length > 0">
        <!-- Список коллекций -->
        <lp-category-cell
          *ngFor="let collection of activeCollections"
          [category]="collection"
          [withBackground]="true"
        ></lp-category-cell>

        <!-- Категория "Новые" -->
        <lp-category-cell
          *ngIf="allowActiveCollectionsViewing"
          [category]="newCategoryItem"
          [withBackground]="true"
        ></lp-category-cell>

        <!-- Список фильтров -->
        <lp-category-cell
          *ngFor="let category of categories"
          [category]="category"
          (cellClick)="onSelectMainCategory($event)"
        ></lp-category-cell>
      </ng-container>
    </app-carousel>
  </ng-template>

  <!-- Заголовок с кнопкой "Назад" -->
  <div class="header">
    <div>
      <lp-category-header
        *ngIf="selectedCell; else productRequestButtonTmp"
        [title]="selectedCell.name"
        (back)="onResetCategory()"
      ></lp-category-header>
    </div>

    <ng-content></ng-content>
  </div>
</div>

<ng-template #productRequestButtonTmp>
  <lp-product-request-button *ngxPermissionsOnly="['loyaltyProgramProductRequestViewing']"></lp-product-request-button>
</ng-template>
